import { useEffect, useState } from "react";
import axios from "axios";
import { Gift, Crown } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { getClientId, getProEmail, setProEmail } from "@/lib/account";

const inputCls = "flex-1 rounded-full bg-[#090A0F] border border-white/10 px-5 py-3 text-sm text-slate-100 placeholder:text-slate-600 outline-none focus:border-amber-500/60 transition-colors";

export const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86400000));

export const ProTrial = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const saved = getProEmail();
    if (saved) axios.get(`${API}/pro/status`, { params: { email: saved } }).then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/pro/trial`, { email, client_id: getClientId(), origin_url: window.location.origin });
      setProEmail(email);
      setStatus({ pro: true, plan: "pro", trial_ends_at: data.trial_ends_at });
      toast.success("Prova Pro attivata! Hai 7 giorni di generazioni illimitate.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossibile attivare la prova. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  if (status?.pro) {
    return (
      <div className="rounded-3xl border border-emerald-500/30 bg-emerald-500/[0.06] p-6 flex items-center gap-3" data-testid="trial-active">
        <Crown className="w-5 h-5 text-emerald-300 shrink-0" />
        <p className="text-sm text-emerald-200">
          {status.trial_ends_at ? <>Prova Pro attiva: <strong data-testid="trial-days-left">{daysLeft(status.trial_ends_at)} giorni</strong> rimasti. Abbonati qui sotto per non perdere l'accesso illimitato.</> : <>Piano {status.plan} attivo su questo dispositivo.</>}
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} id="prova" data-testid="trial-form" className="rounded-3xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/[0.08] to-[#0d0f17] p-8 sm:p-10 grid lg:grid-cols-2 gap-8 items-center">
      <div>
        <div className="flex items-center gap-2 font-display text-xl font-bold"><Gift className="w-5 h-5 text-emerald-300" /> Prova Pro gratis per 7 giorni</div>
        <p className="text-slate-400 mt-2 text-sm">Nessuna carta richiesta. Generazioni illimitate, piani a 30 giorni e analisi concorrenti, subito. Dopo 7 giorni torni al piano gratuito se non ti abboni.</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="la-tua@email.it" data-testid="input-trial-email" className={inputCls} />
        <button type="submit" disabled={loading} data-testid="btn-start-trial"
          className="rounded-full bg-emerald-400 px-6 py-3 font-semibold text-sm text-slate-950 transition-colors hover:bg-emerald-300 disabled:opacity-50">
          {loading ? "Attivazione…" : "Attiva la prova gratuita"}
        </button>
      </div>
    </form>
  );
};
